import { render, staticRenderFns } from "./BottomSheet.vue?vue&type=template&id=0f6bcdb1&scoped=true&"
import script from "./BottomSheet.vue?vue&type=script&lang=js&"
export * from "./BottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheet.vue?vue&type=style&index=0&id=0f6bcdb1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6bcdb1",
  null
  
)

export default component.exports